import React from 'react';

import { Nav } from '../components/Nav';
import { Footer } from '../components/Footer';
import { MetaTagsComponent } from '../components/MetaTags';

const SignIn = () => {

  return (
    <>
      <MetaTagsComponent lang="signin" />
      <Nav />
      <section id='sign-in'>
        <div className='container tc'>
          <div className='s-80'></div>
          <h1 className='title-intro'>
            Sign In
          </h1>
          <div className='s-48'></div>
          <div style={{position: 'relative', height: '80dvh', overflow: 'auto'}}>
            <iframe 
              src="https://form.esupport.org.ua/s/dw12thpa6x489l429vaz83au?embed=true" 
              frameBorder="0" 
              title="Course Registration Form"
              style={{position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', border: 0}}
            />
          </div>
          <div className='s-80'></div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export { SignIn };